import { envStore } from '@shared/env'
import renderer from '@shared/innmaxLib/utils/renderer'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

// @ts-ignore
window.__webpack_nonce__ = envStore.cspNonce
// styled-components 需要以下設定方式才會生效
// @ts-ignore
__webpack_nonce__ = window.__webpack_nonce__

// @ts-ignore
window.recaptchaOptions = {
  nonce: envStore.cspNonce,
}

if (envStore.isEnvDev) {
  // const { server } = require('../../mocks')
  // server.start({
  //   serviceWorker: {
  //     url: `${envStore.publicUrl}/mockServiceWorker.js`,
  //   },
  // })
}

// @ts-ignore
;(window as any).webVersion = `${webVersion}`

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(renderer()(App))

// root.render(
//   <React.StrictMode>
//     {renderer()(App)}
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
